import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axiosConfig';

// Crear torneo (admin)
export const createTournament = createAsyncThunk(
    'tournaments/createTournament',
    async ({ slug, data }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`/${slug}/api/tournaments`, data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Obtener todos los torneos de un salón (slug)
export const fetchTournaments = createAsyncThunk(
    'tournaments/fetchTournaments',
    async (slug, { rejectWithValue }) => {
        try {
            const response = await axios.get(`/${slug}/api/tournaments`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Obtener TODOS los torneos (Global)
export const fetchGlobalTournaments = createAsyncThunk(
    'tournaments/fetchGlobalTournaments',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`/api/tournaments`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Obtener detalles de un torneo de un salón (slug + id)
export const fetchTournamentDetails = createAsyncThunk(
    'tournaments/fetchTournamentDetails',
    async ({ slug, id }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`/${slug}/api/tournaments/${id}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// **Actualizar** un torneo
export const updateTournament = createAsyncThunk(
    'tournaments/updateTournament',
    async ({ slug, id, data }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`/${slug}/api/tournaments/${id}`, data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// **Eliminar** un torneo
export const deleteTournament = createAsyncThunk(
    'tournaments/deleteTournament',
    async ({ slug, id }, { rejectWithValue }) => {
        try {
            await axios.delete(`/${slug}/api/tournaments/${id}`);
            return id;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);


const tournamentSlice = createSlice({
    name: 'tournaments',
    initialState: {
        tournaments: [],
        tournamentDetails: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Crear torneo
            .addCase(createTournament.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createTournament.fulfilled, (state, action) => {
                state.tournaments.push(action.payload);
                state.loading = false;
            })
            .addCase(createTournament.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Obtener todos los torneos por salón
            .addCase(fetchTournaments.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTournaments.fulfilled, (state, action) => {
                state.tournaments = action.payload;
                state.loading = false;
            })
            .addCase(fetchTournaments.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Obtener todos los torneos (Global)
            .addCase(fetchGlobalTournaments.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchGlobalTournaments.fulfilled, (state, action) => {
                state.tournaments = action.payload;
                state.loading = false;
            })
            .addCase(fetchGlobalTournaments.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Obtener detalles
            .addCase(fetchTournamentDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.tournamentDetails = null;
            })
            .addCase(fetchTournamentDetails.fulfilled, (state, action) => {
                state.tournamentDetails = action.payload;
                state.loading = false;
            })
            .addCase(fetchTournamentDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.tournamentDetails = null;
            })

            // Actualizar
            .addCase(updateTournament.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateTournament.fulfilled, (state, action) => {
                state.loading = false;
                const updated = action.payload;
                const index = state.tournaments.findIndex((t) => t._id === updated._id);
                if (index !== -1) {
                    state.tournaments[index] = updated;
                }
                if (state.tournamentDetails && state.tournamentDetails._id === updated._id) {
                    state.tournamentDetails = updated;
                }
            })
            .addCase(updateTournament.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Eliminar
            .addCase(deleteTournament.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteTournament.fulfilled, (state, action) => {
                state.loading = false;
                state.tournaments = state.tournaments.filter((t) => t._id !== action.payload);
            })
            .addCase(deleteTournament.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default tournamentSlice.reducer;
